"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AverageAggregator = void 0;
const bus_bindings_aggregator_factory_1 = require("@comunica/bus-bindings-aggregator-factory");
const Eval = __importStar(require("@comunica/utils-expression-evaluator"));
class AverageAggregator extends bus_bindings_aggregator_factory_1.AggregateEvaluator {
    dataFactory;
    additionFunction;
    divisionFunction;
    state = undefined;
    constructor(evaluator, distinct, dataFactory, additionFunction, divisionFunction, throwError) {
        super(evaluator, distinct, throwError);
        this.dataFactory = dataFactory;
        this.additionFunction = additionFunction;
        this.divisionFunction = divisionFunction;
    }
    emptyValueTerm() {
        return Eval.typedLiteral('0', Eval.TypeURL.XSD_INTEGER);
    }
    putTerm(term) {
        if (this.state === undefined) {
            const sum = this.termToNumericOrError(term);
            this.state = { sum, count: 1 };
        }
        else {
            const internalTerm = this.termToNumericOrError(term);
            this.state.sum = this.additionFunction
                .applyOnTerms([this.state.sum, internalTerm], this.evaluator);
            this.state.count++;
        }
    }
    termResult() {
        if (this.state === undefined) {
            return this.emptyValue();
        }
        const count = new Eval.IntegerLiteral(this.state.count);
        const result = this.divisionFunction.applyOnTerms([this.state.sum, count], this.evaluator);
        return result.toRDF(this.dataFactory);
    }
}
exports.AverageAggregator = AverageAggregator;
//# sourceMappingURL=AverageAggregator.js.map